import { useState } from 'react'
import { AxiosError } from 'axios'

const useHttpLoader = () => {
  const [loading, setLoading] = useState(false)

  const wait = <T>(p: Promise<T>, onLoad?: (v: T) => void, onError?: (err: AxiosError) => void) => {
    setLoading(true)

    return p
      .then((r) => {
        if (onLoad) onLoad(r)
        setLoading(false)
      })
      .catch((err) => {
        if (onError) onError(err)
        setLoading(false)
      })
  }

  return { loading, wait }
}

export default useHttpLoader
